function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 256a160 160 0 1 1 320 0 160 160 0 1 1-320 0",
  style: {
    opacity: 0.4
  }
}));
export default SvgCircleSmall;